//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    },
    showBtns: {
      type: Boolean,
      required: true
    },
    btnName: {
      type: String,
      required: false,
      default: ''
    },
    btnLink: {
      type: String,
      required: false,
      default: ''
    },
    btnName2: {
      type: String,
      required: false,
      default: ''
    },
    btnLink2: {
      type: String,
      required: false,
      default: ''
    },
    showMobText: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    goToLink (link) {
      event.preventDefault()
      event.stopPropagation()
      window.open(link, '_blank')
    }
  }
}
